(function () {
  function findInboxToggleButton() {
    var hosts = [
      document.getElementById('ShopifyChat'),
      document.querySelector('inbox-online-store-chat')
    ].filter(Boolean);

    var i;
    var j;
    var root;
    var button;
    var selectors = [
      '.chat-app > button',
      'button.chat-toggle',
      'button[aria-controls="chat-ui"]',
      'button'
    ];

    for (i = 0; i < hosts.length; i++) {
      root = hosts[i].shadowRoot;
      if (!root) {
        continue;
      }

      for (j = 0; j < selectors.length; j++) {
        button = root.querySelector(selectors[j]);
        if (button) {
          return button;
        }
      }
    }

    var iframe = document.querySelector('#ShopifyChat, #dummy-chat-button-iframe');
    if (iframe && iframe.contentWindow && iframe.contentDocument) {
      return iframe.contentDocument.querySelector('.chat-toggle--bottom-right, button');
    }

    return null;
  }

  function openShopifyInbox() {
    var button = findInboxToggleButton();
    if (!button) {
      return false;
    }

    button.click();
    return true;
  }

  function bindLiveChatLinks() {
    var links = document.querySelectorAll('.liveChatAvailability');

    links.forEach(function (link) {
      if (link.dataset.inboxBound === 'true') {
        return;
      }

      link.dataset.inboxBound = 'true';
      link.setAttribute('href', '#');
      link.setAttribute('role', 'button');

      link.addEventListener('click', function (event) {
        event.preventDefault();

        if (openShopifyInbox()) {
          return;
        }

        var attempts = 0;
        var interval = window.setInterval(function () {
          attempts += 1;
          if (openShopifyInbox() || attempts >= 20) {
            window.clearInterval(interval);
          }
        }, 250);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLiveChatLinks);
  } else {
    bindLiveChatLinks();
  }

  if (window.MutationObserver) {
    new MutationObserver(bindLiveChatLinks).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();
